// extracted by mini-css-extract-plugin
module.exports = {"container":"HomeCard_container__2D0LB","textContainer":"HomeCard_textContainer__3VlC_"};